import { useAppSelector } from 'shared';

export const useOutdoorBarsPageState = () => useAppSelector((store) => store.outdoorBarsPage);
